import request from '@/router/axios'
import env from '@/config/env'

// 获取证照目录树
export const tocTree = (params) => {
  return request({
    url: env.officeUrl + '/license/toc/tree',
    method: 'get',
    params
  })
}
// 获取证照分页
export const pageApi = (params) => {
  return request({
    url: env.officeUrl + '/license/page',
    method: 'post',
    data: params
  })
}
// 获取证照枚举
export const licenseEnum = (params) => {
  return request({
    url: env.officeUrl + '/license/enum',
    method: 'get',
    params
  })
}
// 保存证照目录
export const tocSave = (params) => {
  return request({
    url: env.officeUrl + '/license/toc/save',
    method: 'post',
    data: params
  })
}
// 删除证照目录
export const tocDel = (params) => {
  return request({
    url: env.officeUrl + '/license/toc/del',
    method: 'delete',
    params
  })
}
// 搜索员工
export const employeeSearch = (params) => {
  return request({
    url: env.officeUrl + '/employee/search',
    method: 'get',
    params
  })
}
// 保存证照
export const licenseSave = (params) => {
  return request({
    url: env.officeUrl + '/license/save',
    method: 'post',
    data: params
  })
}
// 记录证照
export const licenseUse = (params) => {
  return request({
    url: env.officeUrl + '/license/use',
    method: 'post',
    data: params
  })
}
// 记录证照
export const licenseCancel = (params) => {
  return request({
    url: env.officeUrl + '/license/cancel',
    method: 'post',
    data: params
  })
}

// 获取证照信息
export const licenseDetail = (params) => {
  return request({
    url: env.officeUrl + '/license/detail',
    method: 'get',
    params
  })
}
// 获取证照使用记录分页
export const usePage = (params) => {
  return request({
    url: env.officeUrl + '/license/use/page',
    method: 'post',
    data: params
  })
}
// 获取证照版本记录
export const history = (params) => {
  return request({
    url: env.officeUrl + '/license/history',
    method: 'get',
    params
  })
}
// 获取获取日志分页
export const logPage = (params) => {
  return request({
    url: env.officeUrl + '/license/log',
    method: 'post',
    data: params
  })
}

// 获取公司信息
export const companyDetail = (params) => {
  return request({
    url: env.officeUrl + '/company/detailForLicense',
    method: 'get',
    params
  })
}
